import type { IconsProps } from '@makemydeal/dr-sales-checkin-types';
import React from 'react';
import { StyledDealSummaryIcon } from './dealSummaryIcon.style';

export const DealSummaryIcon: React.FC<IconsProps> = ({ onClick, fill = 'black' }) => (
    <StyledDealSummaryIcon
        data-testid="deal-summary-icon"
        onClick={onClick}
        width="21"
        height="17"
        viewBox="0 0 21 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 3C0 1.34315 1.34315 0 3 0H18C19.6569 0 21 1.34315 21 3V13.5C21 15.1569 19.6569 16.5 18 16.5H3C1.34315 16.5 0 15.1569 0 13.5V3ZM3 1.5C2.17157 1.5 1.5 2.17157 1.5 3V13.5C1.5 14.3284 2.17157 15 3 15H18C18.8284 15 19.5 14.3284 19.5 13.5V3C19.5 2.17157 18.8284 1.5 18 1.5H3ZM12.25 5.25C12.25 4.83579 12.5858 4.5 13 4.5H17.5C17.9142 4.5 18.25 4.83579 18.25 5.25C18.25 5.66421 17.9142 6 17.5 6H13C12.5858 6 12.25 5.66421 12.25 5.25ZM12.25 8.25C12.25 7.83579 12.5858 7.5 13 7.5H17.5C17.9142 7.5 18.25 7.83579 18.25 8.25C18.25 8.66421 17.9142 9 17.5 9H13C12.5858 9 12.25 8.66421 12.25 8.25ZM12.25 11.25C12.25 10.8358 12.5858 10.5 13 10.5H17.5C17.9142 10.5 18.25 10.8358 18.25 11.25C18.25 11.6642 17.9142 12 17.5 12H13C12.5858 12 12.25 11.6642 12.25 11.25Z"
            fill={fill}
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.359 5.69918C10.6632 5.98031 10.6819 6.45481 10.4008 6.75902L6.08832 11.4257C5.94636 11.5793 5.74668 11.6667 5.5375 11.6667C5.32833 11.6667 5.12865 11.5793 4.98668 11.4257L3.29918 9.5996C3.01806 9.29539 3.03678 8.82089 3.34099 8.53976C3.6452 8.25864 4.1197 8.27736 4.40082 8.58157L5.5375 9.8116L9.29918 5.74099C9.58031 5.43678 10.0548 5.41806 10.359 5.69918Z"
            fill={fill}
        />
    </StyledDealSummaryIcon>
);
